export default __webpack_public_path__ + "static/media/global-settings.35cb6b80.svg";